export default "__VITE_ASSET__DTwf_zS5__"